import Swiper from "swiper";
import SwiperCore, { Autoplay, Pagination } from "swiper/core";
import "swiper/swiper-bundle.css";

SwiperCore.use([Pagination, Autoplay]);

const swiper = new Swiper(".trusted-by-slider", {
	loop: true,
	slidesPerView: 1,
	slidesPerGroup: 1,
	autoplay: {
		delay: 500,
	},
	freeMode: false,
	speed: 500,
	grabCursor: true,
	pagination: true,
	breakpoints: {
		768: {
			slidesPerGroup: 3,
			slidesPerView: 3,
			autoplay: {
				delay: 2500,
			},
		},
		960: {
			slidesPerGroup: 4,
			slidesPerView: 4,
			autoplay: {
				delay: 2500,
			},
		},

		1024: {
			slidesPerGroup: 5,
			slidesPerView: 5,
			autoplay: {
				delay: 2500,
			},
		},
	},
});
